export enum MroStatus {
    PENDING = 'PENDING',
    READY_FOR_ACTIVATION = 'READY_FOR_ACTIVATION',
    ACTIVATED = 'ACTIVATED',
    DISCONNECTED = 'DISCONNECTED',
    NON_COMPLIANT = 'NON_COMPLIANT',
    DEACTIVATED_REENROLLABLE = 'DEACTIVATED_REENROLLABLE',
    DEACTIVATED = 'DEACTIVATED',
    CLEARROAD_PENDING = 'CLEARROAD_PENDING',
}
